
export const WEBSITE = {
    DOMAIN: 'www.loveandpawscare.com'
}